/**
 * Busy-on-submit — drop-in guard + spinner for native (non-AJAX) forms.
 *
 * Add `data-busy-submit` to a <form>. On submit, its submit button gets
 * aria-busy="true": CSS renders a spinner and hides the label, and the attribute
 * doubles as the guard against a second submit until the page navigates away.
 * Optionally mark a specific control with `data-busy-submit-target`.
 */
function initBusySubmitForm(form) {
    form.addEventListener('submit', (event) => {
        const button = form.querySelector(
            '[data-busy-submit-target], button[type="submit"], button:not([type]), input[type="submit"]'
        );
        if (!button) {
            return;
        }
        if (button.getAttribute('aria-busy') === 'true') {
            event.preventDefault();
            return;
        }

        button.setAttribute('aria-busy', 'true');
    });
}

function registerBusySubmitForms() {
    document.querySelectorAll('form[data-busy-submit]').forEach(initBusySubmitForm);
}

// bfcache back-navigation restores the page with the button still busy — clear it.
window.addEventListener('pageshow', (event) => {
    if (!event.persisted) {
        return;
    }

    document
        .querySelectorAll('form[data-busy-submit] [aria-busy="true"]')
        .forEach((el) => el.removeAttribute('aria-busy'));
});

const { register } = window.sitchco;
register(registerBusySubmitForms);
